var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './SimpleButton.js';
/**
 * A horizontal group of `<simple-button>` instances that behave as a
 * single-select segmented control. The currently-selected option uses
 * `variantSelected`, the others use `variantUnselected`. Click events
 * dispatch a `value-change` CustomEvent with `{ value }`.
 *
 * Use this when you want two (or more) discrete options laid out as
 * adjacent buttons whose visual emphasis flips on selection — i.e. the
 * "selected" button looks primary while the others look secondary.
 */
let SegmentedToggle = class SegmentedToggle extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.value = '';
        this.variantSelected = 'primary';
        this.variantUnselected = 'secondary';
        this.size = 'medium';
        this.disabled = false;
    }
    handleSelect(value) {
        if (this.disabled || value === this.value)
            return;
        this.value = value;
        this.dispatchEvent(new CustomEvent('value-change', {
            detail: { value },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <div class="ggo-segmented-toggle" role="group">
        ${this.options.map((opt) => html `
            <simple-button
              .label=${opt.label}
              .variant=${opt.value === this.value
            ? this.variantSelected
            : this.variantUnselected}
              .size=${this.size}
              ?disabled=${this.disabled}
              aria-pressed=${opt.value === this.value ? 'true' : 'false'}
              @button-click=${() => this.handleSelect(opt.value)}
            ></simple-button>
          `)}
      </div>
    `;
    }
};
SegmentedToggle.styles = css `
    :host {
      display: inline-flex;
    }

    .ggo-segmented-toggle {
      display: inline-flex;
      gap: 4px;
    }
  `;
__decorate([
    property({ type: Array })
], SegmentedToggle.prototype, "options", void 0);
__decorate([
    property({ type: String })
], SegmentedToggle.prototype, "value", void 0);
__decorate([
    property({ type: String })
], SegmentedToggle.prototype, "variantSelected", void 0);
__decorate([
    property({ type: String })
], SegmentedToggle.prototype, "variantUnselected", void 0);
__decorate([
    property({ type: String })
], SegmentedToggle.prototype, "size", void 0);
__decorate([
    property({ type: Boolean })
], SegmentedToggle.prototype, "disabled", void 0);
SegmentedToggle = __decorate([
    customElement('segmented-toggle')
], SegmentedToggle);
export { SegmentedToggle };
//# sourceMappingURL=SegmentedToggle.js.map